import React from "react";
import SetHeader from "./SetHeader";
import BreadCrumb from "../../layout/BreadCrumb";
import SideTreeMenu from "./SideTreeMenu";
import DocumentAdd from "../excel-upload/DocumentAdd";
import useModalToggle from "../../custom_hooks/useModalToggle"; 
import svg40 from "../../assets/svg/svg40.svg";

function Datasets() {
  const { open, handleCancel, handleOpen } = useModalToggle();

  const handleAdd = async () => {
    handleOpen();
  };
  return (
    <div>
      <div className="flex items-center justify-between">
        <BreadCrumb breadcrumbs={[{ title: "Datasets" }]} />
        <button
          className="cstm-btn  flex items-center gap-[1rem] !w-[200px]"
          type="button"
          onClick={handleAdd}
        >
          <img src={svg40} alt="svg40" /> Add Dataset
        </button>
      </div>

      <SetHeader />
      <div className="flex items-center mt-[.5rem] h-full">
        <SideTreeMenu />
      </div>

      <DocumentAdd isModalOpen={open} handleCancel={handleCancel} />
    </div>
  );
}

export default Datasets;
